import React from 'react';
import { toast } from 'react-hot-toast';

const DateRangeFilter = ({
    startDate,
    endDate,
    onChange,
    containerClassName = "flex items-center space-x-2",
    inputClassName = "input-field text-sm w-36 cursor-pointer",
    allowFutureDates = false,
    maxDate,
    minDate = undefined,
    toastErrorMsg = "To date cannot be before from date"
}) => {
    const effectiveMaxDate = maxDate !== undefined
        ? maxDate
        : (allowFutureDates ? undefined : new Date().toISOString().split('T')[0]);

    const handleStartDateChange = (e) => {
        onChange({ startDate: e.target.value, endDate });
    };

    const handleEndDateChange = (e) => {
        const selectedDate = e.target.value;
        if (startDate && selectedDate && selectedDate < startDate) {
            toast.error(toastErrorMsg);
            return;
        }
        onChange({ startDate, endDate: selectedDate });
    };

    const handleInputClick = (e) => {
        if (e.target.showPicker) {
            e.target.showPicker();
        }
    };

    return (
        <div className={containerClassName}>
            <div className="relative">
                <input
                    type="date"
                    value={startDate || ''}
                    onChange={handleStartDateChange}
                    onClick={handleInputClick}
                    min={minDate}
                    max={effectiveMaxDate}
                    className={inputClassName}
                    title="Start Date"
                />
            </div>
            <span className="text-gray-500 hidden sm:inline">To</span>
            <div className="relative">
                <input
                    type="date"
                    value={endDate || ''}
                    onChange={handleEndDateChange}
                    onClick={handleInputClick}
                    min={startDate || minDate}
                    max={effectiveMaxDate}
                    className={inputClassName}
                    title="End Date"
                />
            </div>
        </div>
    );
};

export default DateRangeFilter;
